import React from 'react';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../app/commonReducer';
import { SearchAdd } from '../../common/search-add';
import { connect } from 'react-redux';
import {
  fetchListNewsData,
  setQueryNewValue,
  updateWatchList,
  REDUCER_NAME,
  notifySaveWatchList,
  updateCWWatchListOrganCodes,
} from './reducer';
import ConstCommon from './../../common/Const';
import EventEmitter, { SHOW_GUEST_POPUP } from '../../helpers/EventEmitter';
import { isNotLoginOrExpired } from '../../helpers/Common';

class Search extends React.PureComponent {
  onInputChange = () => {
    const { isShowNotify, notifySaveWatchList } = this.props;
    if (isShowNotify) {
      notifySaveWatchList(false);
    }
  };

  isCoveredWarrant = () => {
    const { currentCoveredWarrant, watchListId } = this.props;

    return currentCoveredWarrant === watchListId;
  };

  getChildProps = () => {
    const { listOrganizationSearch, listCoveredWarrant } = this.props;
    if (this.isCoveredWarrant()) {
      return {
        listKeyFilter: [
          ConstCommon.listCoveredWarrant.CODE,
          ConstCommon.listCoveredWarrant.NAME,
        ],
        mainKey: ConstCommon.listCoveredWarrant.CODE,
        sortKey: ConstCommon.listCoveredWarrant.CODE,
        listSearch: listCoveredWarrant,
        isCoveredWarrant: true,
      };
    }
    return {
      listKeyFilter: [
        ConstCommon.listOrganization.TICKER,
        ConstCommon.listOrganization.ORGAN_SHORT_NAME,
      ],
      mainKey: 'organCode',
      sortKey: 'ticker',
      listSearch: listOrganizationSearch,
    };
  };

  clickItemSearch = organCode => {
    const { updateWatchList, updateCWWatchListOrganCodes, user } = this.props;
    if (isNotLoginOrExpired(user)) {
      EventEmitter.dispatch(SHOW_GUEST_POPUP);
      return;
    }
    if (this.isCoveredWarrant()) {
      updateCWWatchListOrganCodes(organCode);
    } else {
      updateWatchList(organCode);
    }
  };

  render() {
    const {
      typeSearch,
      dateRangeOption,
      fetchListNewsData,
      setQueryNewValue,
      disabled,
      isBelongToWatchList,
      currentTab,
    } = this.props;

    return (
      <SearchAdd
        {...this.getChildProps()}
        key={currentTab}
        disabled={disabled}
        onChange={this.onInputChange}
        typeSearch={typeSearch}
        dateRangeOption={dateRangeOption}
        fetchListNewsData={fetchListNewsData}
        setQueryNewValue={setQueryNewValue}
        clickItemSearch={this.clickItemSearch}
        keepFocus={currentTab === 1}
        isBelongToWatchList={isBelongToWatchList}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    listOrganizationSearch: state[COMMON_REDUCER_NAME].listOrganizationSearch,
    listCoveredWarrant: state[COMMON_REDUCER_NAME].listCoveredWarrant,
    currentTab: state[REDUCER_NAME].currentTab,
    isShowNotify: state[REDUCER_NAME].notifySaveListWatchList.isShow,
    watchListId: state[REDUCER_NAME].watchListId,
    currentCoveredWarrant: state[REDUCER_NAME].currentCoveredWarrant,
    user: state.userInfo,
  };
};

const mapDispatchToProps = {
  fetchListNewsData,
  setQueryNewValue,
  updateWatchList,
  notifySaveWatchList,
  updateCWWatchListOrganCodes,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Search);
